import Auth from 'j-toker';
import { apiPost, apiPut, apiDelete, apiGet } from 'helpers/ApiHelper';

const makeUrl = (path) => Auth.getApiUrl() + '/landlords' + path;

const buildFormData = (data) => {
  return {
    // Rails accepts_nested_attributes_for expects `*_attributes` param
    policy: { ...data, rules_attributes: data.rules },
  };
};

export function getPolicies() {
  return apiGet(makeUrl('/policies'));
}

export function getAssociations() {
  return apiGet(Auth.getApiUrl() + '/landlords/associations');
}

export function createPolicy(data) {
  const submitData = buildFormData(data);
  return apiPost(makeUrl('/policies'), submitData);
}

export function updatePolicy(data, policyId) {
  const submitData = buildFormData(data);

  return apiPut(makeUrl(`/policies/${policyId}`), submitData);
}

export function deletePolicy(policyId) {
  return apiDelete(makeUrl(`/policies/${policyId}`));
}

export function getPolicyHistory(policyId) {
  return apiGet(Auth.getApiUrl() + `/landlords/policies/${policyId}/history`);
}
